<template>
  <div class="profile">
    <v-container>
      <div class="profile_in">
        <p class="profile_ttl">
          {{ this.texts.title }}
        </p>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.sex }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="gender"
              :items="genderItems"
              :label="labelGender"
              required
              class="select"
              return-object
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.age }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="age"
              return-object
              :items="ageItems"
              :label="labelAge"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.prefecture }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="prefecture"
              :items="prefectureItems"
              :label="this.texts.label_prefecture"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.occupation }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="occupation"
              :items="occupationItems"
              :label="this.texts.label_occupation"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.workstyle }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="workStyle"
              :items="workStyleItems"
              :label="this.texts.label_workstyle"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.remote_frequency }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <p>{{ this.texts.zaitaku_text }}</p>
            <v-select
              @change="getOptionsIndex"
              v-model="wfhFrequency"
              v-if="isWfhSelected"
              :items="wfhFrequencyItems"
              :label="this.texts.label_wfh"
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.personal_income
              }}<span class="profile_rowTtlSub">{{ this.texts.optional }}</span>
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="personalIncome"
              :items="familyIncomeItems"
              :label="this.texts.label_personal_income"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.family_income
              }}<span class="profile_rowTtlSub">{{ this.texts.optional }}</span>
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="familyIncome"
              :items="personalIncomeItems"
              :label="this.texts.label_family_income"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.married }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="marriedStatus"
              :items="marriedStatusItems"
              :label="this.texts.label_mariied"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="12" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.children }}
            </p>
          </v-col>
          <v-col cols="12" sm="9">
            <p>{{ this.texts.select_all }}</p>
            <div class="checkbox_group">
              <label
                v-for="(item, index) of childrenItems"
                :key="item.index"
                :for="'checkbox-' + index + 1"
                class="checkbox_label"
              >
                <input
                  type="checkbox"
                  v-model="children"
                  :value="index"
                  :id="'checkbox-' + index + 1"
                  class="checkbox_input"
                  :disabled="
                    (index != 5 && children.indexOf(5) !== -1) ||
                      (index == 5 &&
                        (children.indexOf(0) !== -1 ||
                          children.indexOf(1) !== -1 ||
                          children.indexOf(2) !== -1 ||
                          children.indexOf(3) !== -1 ||
                          children.indexOf(4) !== -1))
                  "
                />
                <span class="checkbox_labelTxt">{{ item }}</span>
              </label>
            </div>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.height }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="height"
              :items="heightItems"
              :label="this.texts.label_height"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.weight }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-select
              @change="getOptionsIndex"
              v-model="weight"
              :items="weightItems"
              :label="this.texts.label_weight"
              required
              class="select"
              solo
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="profile_row">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.mail
              }}<span class="profile_rowTtlSub">{{ this.texts.optional }}</span>
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-text-field v-model="mail" solo></v-text-field>
            <p>{{ this.texts.mail_text }}</p>
          </v-col>
        </v-row>
        <v-row class="profile_row" style="border-top: none">
          <v-col cols="4" sm="3">
            <p class="profile_rowTtl">
              {{ this.texts.mail_confirm }}
            </p>
          </v-col>
          <v-col cols="8" sm="9">
            <v-text-field
              v-model="mailConfirm"
              :rules="[rules.emailConfirmationRules]"
              solo
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="profile_row profile_btn">
          <button
            v-on:click="postProfileInfo"
            class="btn_next"
            v-if="isAnswered"
          >
            {{ this.texts.save }}
          </button>
          <button class="btn_next is-negative" v-if="!isAnswered">
            {{ this.texts.save }}
          </button>
        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import axios from "axios";
import { mapGetters } from "vuex";
import profileTextJa from "../assets/ProfileTextsJa";
import profileTextEn from "../assets/ProfileTextsEn";
import profileTextCh from "../assets/ProfileTextsCh";
import store from "../store";

export default {
  name: "Profile",
  created() {
    // MyTop遷移時にユーザープロフィールを取得する
    axios
      .get("/users/profile", {
        params: { userName: store.state.loginUserId },
        headers: { Authorization: store.state.accessToken },
      })
      .then((response) => {
        // eslint-disable-next-line
        store.commit("setValueToLoginUserInfo", response["data"]);
        var userInfo = this.getLoginUserInfo;
        this.gender = userInfo["gender"];
        this.age = userInfo["age"];
        this.occupation = userInfo["occupation"];
        this.familyIncome = userInfo["familyIncome"];
        this.personalIncome = userInfo["personalIncome"];
        this.marriedStatus = userInfo["marriedStatus"];
        // 初期入力時はchildrenブランク
        if (this.age > 0) {
          this.children = userInfo["children"].split(",").map((e) => Number(e));
        } else {
          this.children = [];
        }

        this.height = userInfo["height"];
        this.weight = userInfo["weight"];
        this.prefecture = userInfo["prefecture"];
        this.mail = userInfo["mail"];
        this.mailConfirm = userInfo["mail"];
        this.workStyle = userInfo["workStyle"];
        this.wfhFrequency = userInfo["wfhFrequency"];
        this.getOptionsIndex();
      })
      .catch((err) => {
        (this.errored = true), (this.error = err);
      });
    // eslint-disable-next-line
    if (this.getLanguage == "日本語") {
      // eslint-disable-next-line
      this.texts = profileTextJa;
    } else if (this.getLanguage == "English") {
      // eslint-disable-next-line
      this.texts = profileTextEn;
    } else if (this.getLanguage == "中文") {
      // eslint-disable-next-line
      this.texts = profileTextCh;
    }
    this.updateOptions();
  },
  data() {
    return {
      indexDict: {},
      texts: "",
      required: [1, 1, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 0], // currentAnswerのうち任意回答(空欄でよい)属性は0
      gender: "",
      genderItems: "",
      age: "",
      ageItems: Array.from(new Array(83)).map((v, i) => i + 18),
      occupation: "",
      occupationItems: "",
      mail: "",
      mailConfirm: "",
      wfhFrequency: "",
      workStyle: "",
      familyIncome: "",
      familyIncomeItems: "",
      personalIncome: "",
      personalIncomeItems: [],
      marriedStatus: "",
      marriedStatusItems: "",
      height: "",
      heightItems: Array.from(new Array(100)).map((v, i) => i + 130),
      weight: "",
      weightItems: Array.from(new Array(120)).map((v, i) => i + 30),
      prefecture: "",
      prefectureItems: "",
      childrenItems: "",
      children: [],
      wfhFrequencyItems: "",
      workStyleItems: "",
      labelGender: "",
      labelAge: "",
      labelPrefecture: "",
      labelOccupation: "",
      labelWorkstyle: "",
      labelWfh: "",
      labelPersonalIncome: "",
      labelFamilyIncome: "",
      labelMarried: "",
      labelHeight: "",
      labelWeight: "",
      rules: {
        emailConfirmationRules: (v) =>
          v == this.mail || "メールアドレスが一致していません。",
      },
    };
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser().then((user) => {
      this.user = user;
    });
  },
  watch: {
    returnLanguage() {
      // eslint-disable-next-line
      if (this.getLanguage == "日本語") {
        // eslint-disable-next-line
        this.texts = profileTextJa;
      } else if (this.getLanguage == "English") {
        // eslint-disable-next-line
        this.texts = profileTextEn;
      } else if (this.getLanguage == "中文") {
        // eslint-disable-next-line
        this.texts = profileTextCh;
      }
      this.updateOptions();
      this.updateAnserByIndex();
    },
  },
  methods: {
    updateOptions() {
      this.genderItems = this.texts.gender_items;
      this.familyIncomeItems = this.texts.family_income_items;
      this.personalIncomeItems = this.texts.family_income_items;
      this.marriedStatusItems = this.texts.married_status_items;
      this.childrenItems = this.texts.children_items;
      this.wfhFrequencyItems = this.texts.work_frequency_items;
      this.workStyleItems = this.texts.workstyle_items;
      this.prefectureItems = this.texts.prefecture_items;
      this.occupationItems = this.texts.occupation_items;
      this.labelGender = this.texts.label_gender;
      this.labelAge = this.texts.label_age;
      this.labelPrefecture = this.texts.label_prefecture;
      this.labelOccupation = this.texts.label_occupation;
      this.labelWorkstyle = this.texts.label_workstyle;
      this.labelWfh = this.texts.label_wfh;
      this.labelPersonalIncome = this.texts.label_personal_income;
      this.labelFamilyIncome = this.texts.label_family_income;
      this.labelMarried = this.texts.label_married;
      this.labelHeight = this.texts.label_height;
      this.labelWeight = this.texts.label_weight;
    },
    updateAnserByIndex() {
      this.gender = this.genderItems[this.indexDict["gender"]];
      this.age = this.ageItems[this.indexDict["age"]];
      this.occupation = this.occupationItems[this.indexDict["occupation"]];
      this.prefecture = this.prefectureItems[this.indexDict["prefecture"]];
      this.personalIncome =
        this.personalIncomeItems[this.indexDict["personalIncome"]];
      this.familyIncome =
        this.familyIncomeItems[this.indexDict["familyIncome"]];
      this.marriedStatus =
        this.marriedStatusItems[this.indexDict["marriedStatus"]];
      this.workStyle = this.workStyleItems[this.indexDict["workStyle"]];
      this.wfhFrequency =
        this.wfhFrequencyItems[this.indexDict["wfhFrequency"]];
    },
    getOptionsIndex() {
      this.indexDict["gender"] = this.genderItems.findIndex(
        (gender) => gender === this.gender
      );
      this.indexDict["age"] = this.ageItems.findIndex(
        (age) => age === this.age
      );
      this.indexDict["occupation"] = this.occupationItems.findIndex(
        (occupation) => occupation === this.occupation
      );
      this.indexDict["prefecture"] = this.prefectureItems.findIndex(
        (prefecture) => prefecture === this.prefecture
      );
      this.indexDict["personalIncome"] = this.personalIncomeItems.findIndex(
        (personalIncome) => personalIncome === this.personalIncome
      );
      this.indexDict["familyIncome"] = this.familyIncomeItems.findIndex(
        (familyIncome) => familyIncome === this.familyIncome
      );
      this.indexDict["marriedStatus"] = this.marriedStatusItems.findIndex(
        (marriedStatus) => marriedStatus === this.marriedStatus
      );
      this.indexDict["children"] = this.childrenItems.findIndex(
        (children) => children === this.children
      );
      this.indexDict["workStyle"] = this.workStyleItems.findIndex(
        (workStyle) => workStyle === this.workStyle
      );
      this.indexDict["wfhFrequency"] = this.wfhFrequencyItems.findIndex(
        (wfhFrequency) => wfhFrequency === this.wfhFrequency
      );
    },
    postProfileInfo() {
      axios
        .post("/users/profile", this.currentAnswer, {
          headers: { Authorization: this.getAccessToken },
          data: {},
        })
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$emit("inputProfile");
          if (this.$route.path != "/question") {
            this.toMytopPath();
          }
          axios
            .get("/users/profile", {
              params: { userName: this.getLoginUserId },
              headers: { Authorization: this.getAccessToken },
            })
            .then((response) => {
              // eslint-disable-next-line
              store.commit("setValueToLoginUserInfo", response["data"]);
              this.hasProfile = this.getLoginUserInfo["is_profile_entered"];
            })
            .catch((err) => {
              (this.errored = true), (this.error = err);
            });
        })
        .catch((err) => {
          (this.errored = true), (this.error = err);
        });
    },
    toQuestionPath() {
      this.$router.push("/question");
    },
    toAnalyticsPath() {
      this.$router.push("/analytics");
    },
    toMytopPath() {
      this.$router.push("/mytop");
    },
  },
  computed: {
    ...mapGetters([
      "getLoginState",
      "getLoginUserId",
      "getLoginUserInfo",
      "getAccessToken",
      "getLanguage",
      "getCurrentDiagnosisId",
    ]),
    returnLanguage() {
      return this.getLanguage;
    },
    currentAnswer: function() {
      return {
        userId: this.getLoginUserId,
        gender: this.gender,
        age: this.age,
        occupation: this.occupation,
        prefecture: this.prefecture,
        personalIncome: this.personalIncome,
        familyIncome: this.familyIncome,
        marriedStatus: this.marriedStatus,
        children: this.children,
        height: this.height,
        weight: this.weight,
        mail: this.mail,
        mailConfirm: this.mailConfirm,
        workStyle: this.workStyle,
        wfhFrequency: this.wfhFrequency,
      };
    },
    isAnswered: function() {
      if (
        !(
          this.currentAnswer.gender == null || this.currentAnswer.gender == ""
        ) &&
        !(this.currentAnswer.age == null || this.currentAnswer.age == "") &&
        !(
          this.currentAnswer.occupation == null ||
          this.currentAnswer.occupation == ""
        ) &&
        !(
          this.currentAnswer.prefecture == null ||
          this.currentAnswer.prefecture == ""
        ) &&
        !(
          this.currentAnswer.workStyle == null ||
          this.currentAnswer.workStyle == ""
        ) &&
        !(
          this.currentAnswer.marriedStatus == null ||
          this.currentAnswer.marriedStatus == ""
        ) &&
        !(
          this.currentAnswer.children == null ||
          this.currentAnswer.children == ""
        ) &&
        !(
          this.currentAnswer.height == null || this.currentAnswer.height == ""
        ) &&
        !(this.currentAnswer.weight == null || this.currentAnswer.weight == "")
      ) {
        if (this.currentAnswer.workStyle == "在宅勤務") {
          if (
            !(
              this.currentAnswer.wfhFrequency == null ||
              this.currentAnswer.wfhFrequency == ""
            )
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    isWfhSelected: function() {
      return this.workStyle == this.workStyleItems[0] ? true : false;
    },
  },
};
</script>
<style lang="scss" scoped>
$xs: "320px";
$sm: "480px";
$md: "800px";
html {
  background-color: #5592c6;
}
.profile {
  background-color: #5592c6;
  color: #fff;
  width: 100%;
  padding-bottom: 60px;
  &_in {
    background: rgba(0, 0, 128, 0.2);
    border-radius: 6px;
    padding: 48px;
    @media screen and (max-width: $md) {
      padding: 20px;
    }
  }
  &_row {
    border-top: solid 1px #ccc;
    padding: 16px 0 0;
    align-items: center;
  }
  &_ttl {
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0.05em;
    padding-bottom: 24px;
    @media screen and (max-width: $md) {
      font-size: 20px;
      padding: 16px 0;
    }
  }
  &_rowTtl {
    font-weight: bold;
    letter-spacing: 0.05em;
    margin-bottom: 10px !important;
  }
  &_rowTtlSub {
    font-size: 12px;
    display: block;
  }
  &_btn {
    text-align: center;
    justify-content: center;
  }
}
.menuTitle {
  text-align: center;
  font-size: 24px;
  color: #5592c6;
  font-weight: bold;
}

.select {
  margin-bottom: -16px !important;
  max-width: 320px;
}

.v-text-field.textarea_inline {
  width: 5em;
  display: inline-block;
  margin: 0 0.5em;
  &-wide {
    max-width: 320px;
  }
}

.v-messages__message.message-transition-enter-to {
  font-size: 16px !important;
}
</style>
